import { CALLING_EXTENSIONS_INBOUND_CALLING, CALLING_THIRD_PARTY_CHANNELS } from 'calling-internal-common/constants/CallingGates';
import { isDemoWidgetInstalled } from './isDemoWidgetInstalled';
import { getSettingString } from './localSettingsOperators';
export const SUPPORTS_INBOUND_CALLING_KEY = 'supportsInboundCalling';
const SUPPORTS_INBOUND_CALLING_VALUE = 'true';
export const isExtensionsInboundCallingEnabledInLocalStorage = () => {
  return getSettingString(SUPPORTS_INBOUND_CALLING_KEY) === SUPPORTS_INBOUND_CALLING_VALUE;
};
export const isExtensionsInboundCallingEnabledInApi = callingProviders => {
  return Boolean(callingProviders && callingProviders.some(provider => provider.supportsInboundCalling === true));
};
export const isExtensionsInboundCallingEnabled = (gates, callingProvider, callingProviders) => {
  return Boolean(gates && gates.includes(CALLING_THIRD_PARTY_CHANNELS) || gates && gates.includes(CALLING_EXTENSIONS_INBOUND_CALLING) || callingProvider && callingProvider.get('supportsInboundCalling') === true || isExtensionsInboundCallingEnabledInLocalStorage() || isExtensionsInboundCallingEnabledInApi(callingProviders));
};
export const isExtensionsInboundCallingEnabledForDemoWidget = (gates, callingProvider) => {
  return isExtensionsInboundCallingEnabled(gates, callingProvider) && isDemoWidgetInstalled();
};